export default __webpack_public_path__ + "static/media/rubik-v12-latin-900.c625c859.ttf";